import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=8768ecc8&"
import script from "./ItemsList.vue?vue&type=script&lang=js&"
export * from "./ItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports